import React from 'react'
import { Autor, FooterContainer } from './Footer.elements'

const Footer = () => {
  return (
    <FooterContainer>
        <Autor>Developed by Agusdev 🚀 </Autor>
    </FooterContainer>
  )
}

export default Footer